import { render, staticRenderFns } from "./customizedServices.vue?vue&type=template&id=dbae3890&scoped=true&"
import script from "./customizedServices.vue?vue&type=script&lang=js&"
export * from "./customizedServices.vue?vue&type=script&lang=js&"
import style0 from "./customizedServices.vue?vue&type=style&index=0&id=dbae3890&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbae3890",
  null
  
)

export default component.exports